<h2 mat-dialog-title>{{ 'DIALOGS.ORDER_INFORMATION_TITLE' | translate }}</h2>
<mat-dialog-content>
  <lfw-order-details [order]="order()" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial mat-dialog-close>{{ 'DIALOGS.CLOSE' | translate }}</button>
</mat-dialog-actions>
